import { useTranslation } from 'react-i18next';
import { useState, useEffect, useMemo } from 'react';
import ImgCar1 from '../assets/CarrHero4.webp';
import ImgCar2 from '../assets/CarrHero5.webp';
import ImgCar3 from '../assets/CarrHero3.webp';
import ImgCar4 from '../assets/CarrHero1.webp';
import ImgCar5 from '../assets/CarrHero2.webp';

const Hero = () => {
  const { t } = useTranslation();
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  // Array de imágenes del carrusel optimizado con useMemo
  const carouselImages = useMemo(() => [
    
    { src: ImgCar1, alt: "Carrusel Hero 1" },
    { src: ImgCar2, alt: "Carrusel Hero 2" },
    { src: ImgCar3, alt: "Carrusel Hero 3" },
    { src: ImgCar4, alt: "Carrusel Hero 4" },
    { src: ImgCar5, alt: "Carrusel Hero 5" }
  ], []);

  // Cambio automático de imagen cada 4 segundos
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) => 
        prevIndex === carouselImages.length - 1 ? 0 : prevIndex + 1
      );
    }, 4000);

    return () => clearInterval(interval);
  }, [carouselImages.length]);

  return (
    <section className="hero-section flex flex-col lg:flex-row items-center justify-between" id="inicio">
      <div className="hero-content w-full lg:w-1/2 mb-8 lg:mb-0">
        <div className=' hero-texts'>
        <div className="purple-title ">
        <h1 className="font-archivo font-medium text-greyBase tracking-wide">
          {/* Business Support  azul claro*/}
          {t('hero.business_support')} 
        </h1>
        </div>
        <div className='space-y-0 mb:space-y-1 tabs:space-y-1'>
          <h1 className="font-archivo text-primary font-bold resp-h1" style={{ letterSpacing: '2px', lineHeight: '110%', marginBottom: '0' }}>
            {t('hero.main_title')}
          </h1>
          <h2 className="font-archivo text-primary font-semibold resp-h3" style={{ letterSpacing: '1px', marginBottom: '0.25rem' }}>
            {t('hero.main_title_sub')}
          </h2>
            <h2 className="font-sans text-secondary font-semibold text-h3 mb:resp-h4" style={{ lineHeight: '130%', marginTop: '0' }}>
              {/* subtitulo azul oscuro */}
              {t('hero.subtitle').split('\\n').map((line, idx) => (
                <span key={idx}>
                  {line}
                  {idx !== t('hero.subtitle').split('\\n').length - 1 && <br />}
                </span>
              ))}
            </h2>
            
            <h3 className="font-archivo text-primary  font-bold text-h4 mb:resp-h4"style={{ lineHeight: '130%' }}>
              {/* subtitulo azul oscuro */}
              {t('hero.subtitle2').split('\\n').map((line, idx) => (
                <span key={idx}>
                  {line}
                  {idx !== t('hero.subtitle2').split('\\n').length - 1 && <br />}
                </span>
              ))}
            </h3>
              
            
        </div>
      
            <p className="font-content hero-p resp-body5" dangerouslySetInnerHTML={{ __html: t('hero.description') }} />
            {t('hero.description2') && (
              <p className="font-content hero-p resp-body3">{t('hero.description2')}</p>
            )}
          <button className="font-archivo resp-body5 btn-secondary  mt-10"
          onClick={() => {
            const contactSection = document.getElementById('contacto');
            if (contactSection) {
              contactSection.scrollIntoView({ behavior: 'smooth' });
            }
          }}
          > 
          
            {/* boton de demo */}
            {t('hero.demo_btn')}
          </button>
        </div>
    
      </div>
      
      {/* Carrusel de imágenes */}
      <div className="hero-image-container relative w-full lg:w-1/2 px-4 lg:px-0" style={{ paddingTop: '30px' }}>
        {/* Imagen principal del carrusel */}
        <div 
          className="relative overflow-hidden rounded-lg h-64 sm:h-80 md:h-96 lg:h-[500px]"
          style={{
            width: '100%',
            position: 'relative'
          }}
        >
          {carouselImages.map((image, index) => (
            <img
              key={index}
              src={image.src}
              alt={image.alt}
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                objectFit: 'contain',
                opacity: index === currentImageIndex ? 1 : 0,
                transition: 'opacity 1s ease-in-out',
                zIndex: index === currentImageIndex ? 2 : 1
              }}
            />
          ))}
        </div>
      </div>

    </section>
  );
};

export default Hero;
